// All enums availble from build script
import allEnums from "../../_enums/enums.json";

// Enum decorator
import EnumObjectDecorator from "./enumObjectDecorator";

// Destructure Enums
const {
  buildingProjectStageEnums,
  buildingTypeEnum,
  constructionElectricitySupplyEnum,
  constructionHeatSupplyEnum,
  indicatorTypeEnums,
  materialMappingMethodEnum,
  materialSourceEnum,
  operationElectricitySupplyEnum,
  operationHeatSupplyEnum,
  transportBuildingMaterialErrors,
} = allEnums;

// Decorate Enums
const BuildingProjectStageEnums = new EnumObjectDecorator(buildingProjectStageEnums);
const BuildingTypeEnum = new EnumObjectDecorator(buildingTypeEnum);
const ConstructionElectricitySupplyEnum = new EnumObjectDecorator(constructionElectricitySupplyEnum);
const ConstructionHeatSupplyEnum = new EnumObjectDecorator(constructionHeatSupplyEnum);
const IndicatorTypeEnums = new EnumObjectDecorator(indicatorTypeEnums);
const MaterialMappingMethodEnum = new EnumObjectDecorator(materialMappingMethodEnum);
const MaterialSourceEnum = new EnumObjectDecorator(materialSourceEnum);
const OperationElectricitySupplyEnum = new EnumObjectDecorator(operationElectricitySupplyEnum);
const OperationHeatSupplyEnum = new EnumObjectDecorator(operationHeatSupplyEnum);
const TransportBuildingMaterialErrors = new EnumObjectDecorator(transportBuildingMaterialErrors);

// Export Enums
export {
  BuildingProjectStageEnums,
  BuildingTypeEnum,
  ConstructionElectricitySupplyEnum,
  ConstructionHeatSupplyEnum,
  IndicatorTypeEnums,
  MaterialMappingMethodEnum,
  MaterialSourceEnum,
  OperationElectricitySupplyEnum,
  OperationHeatSupplyEnum,
  TransportBuildingMaterialErrors,
};
